// eslint-disable-next-line no-unused-vars
import React from 'react';
import { SI_LABELS } from '../constants';
import VehicleTypeFilterItem from '../vehicle-type-filter-item';
import VehicleGroupFilterItem from '../vehicle-group-filter-item';
import FedStandardCodeFilterItem from '../fed-standard-code-filter-item';
import {
  FED_STANDARD_CODE_FILTER,
  VEHICLE_GROUP_FILTER,
  VEHICLE_TYPE_FILTER,
  FEDERAL_STANDARDS_HIERARCHY,
} from './filter-item-constants';

const getOptions = (options, optionKey) => {
  if (!options || !optionKey) {
    return [];
  }
  return options[optionKey];
};

const nextYear = new Date().getFullYear() + 1;

// eslint-disable-next-line import/prefer-default-export
export const getFilterStructure = (filterOptions, standardItemsFilter) => [
  {
    key: 'year',
    title: 'Contract year',
    type: 'select',
    options: getOptions(filterOptions, 'year'),
    value: standardItemsFilter?.year || nextYear.toString(),
    operator: 'EQ',
    expanded: true,
    hideClear: true,
  },
  {
    key: 'standardItemNumber',
    title: SI_LABELS.NUMBER,
    type: 'typeahead',
    value: standardItemsFilter?.standardItemNumber || '',
    operator: 'EQ',
    expanded: true,
    hideClear: true,
    customFieldProps: { inputCharNum: 1 },
  },
  {
    title: 'Federal standards',
    key: FEDERAL_STANDARDS_HIERARCHY,
    expanded: true,
    filters: [
      {
        key: FED_STANDARD_CODE_FILTER,
        title: 'Federal standard code',
        component: FedStandardCodeFilterItem,
        permanent: false,
        operator: 'EQ',
        value: standardItemsFilter?.fedStandardCode || '',
      },
      {
        key: VEHICLE_GROUP_FILTER,
        title: 'Vehicle group',
        component: VehicleGroupFilterItem,
        permanent: false,
        operator: 'EQ',
        value: standardItemsFilter?.vehicleGroup || '',
      },
      {
        key: VEHICLE_TYPE_FILTER,
        title: 'Vehicle type',
        component: VehicleTypeFilterItem,
        permanent: false,
        operator: 'EQ',
        value: standardItemsFilter?.vehicleType || '',
      },
    ],
  },
  {
    key: 'status',
    id: 'status',
    title: SI_LABELS.STATUS,
    type: 'multiselect',
    options: [
      { label: 'Active', value: '1' },
      { label: 'Inactive', value: '0' },
    ],
    value: standardItemsFilter?.status || ['1'],
    operator: 'IN',
    expanded: true,
    permanent: false,
    hideClear: true,
  },
  {
    key: 'title',
    title: SI_LABELS.TITLE,
    type: 'typeahead',
    value: standardItemsFilter?.title || '',
    operator: 'EQ',
    expanded: true,
    hideClear: true,
    customFieldProps: { inputCharNum: 1 },
  },
  {
    key: 'fast',
    title: SI_LABELS.FASTCODE,
    type: 'select',
    options: getOptions(filterOptions, 'fastCodes'),
    value: standardItemsFilter?.fast || '',
    operator: 'EQ',
    expanded: true,
    hideClear: true,
  },
  {
    key: 'tags',
    title: SI_LABELS.TAGS,
    type: 'multiselect',
    options: getOptions(filterOptions, 'tags'),
    value: standardItemsFilter?.tags || [],
    operator: 'JSON_CONTAINS',
    expanded: true,
    hideClear: true,
  },
];
